declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_relation_atom_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['item_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_relation_atom_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['item_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_relation_atom_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['item_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_relation_atom_4 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['item_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table_relation_atom_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table_relation_atom_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__option_content_shm_hitalama_map_widget_float_table_relation_atom_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['option_content'] >
		,
		ReturnType< $mol_select['option_content'] >
	>
	type $mol_select__trigger_content_shm_hitalama_map_widget_float_table_relation_atom_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_relation_atom_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_relation_atom_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_relation_atom_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_relation_atom_12 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['create_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	export class $shm_hitalama_map_widget_float_table_relation_atom extends $mol_view {
		item_label( ): string
		item_content( ): readonly(any)[]
		item_open( next?: any ): any
		item_current( ): boolean
		Item( ): $mol_button_minor
		item_visible( ): readonly(any)[]
		option_content( id: any): readonly(any)[]
		Picker_icon( ): $mol_icon_dots_vertical
		Picker( ): $mol_select
		create( next?: any ): any
		Create_icon( ): $mol_icon_plus
		create_current( ): boolean
		Create( ): $mol_button_minor
		value( next?: string ): string
		dictionary( ): Record<string, any>
		active( ): string
		open( next?: any ): any
		sub( ): readonly(any)[]
	}
	
	type $mol_check_box__title_shm_hitalama_map_widget_float_table_relation_list_checks_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list_checks['check_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__sub_shm_hitalama_map_widget_float_table_relation_list_checks_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list_checks['check_content'] >
		,
		ReturnType< $mol_check_box['sub'] >
	>
	export class $shm_hitalama_map_widget_float_table_relation_list_checks extends $shm_check_list {
		check_title( id: any): string
		check_content( id: any): readonly(any)[]
		relation( ): any
		Check( id: any): $mol_check_box
	}
	
	type $shm_hitalama_map_widget_float_table_relation_list_checks__relation_shm_hitalama_map_widget_float_table_relation_list_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['relation_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list_checks['relation'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list_checks__options_shm_hitalama_map_widget_float_table_relation_list_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['option_ids'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list_checks['options'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list_checks__value_shm_hitalama_map_widget_float_table_relation_list_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list_checks['value'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_widget_float_table_relation_list_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_widget_float_table_relation_list_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_relation_list_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_relation_list_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_relation_list_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_relation_list_9 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table_relation_list['create_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_relation_list_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['item_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_relation_list_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['item_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_relation_list_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['item_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table_relation_list_13 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table_relation_list['item_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	export class $shm_hitalama_map_widget_float_table_relation_list extends $mol_view {
		Picker_icon( ): $mol_icon_dots_vertical
		option_ids( ): readonly(string)[]
		Checks( ): $shm_hitalama_map_widget_float_table_relation_list_checks
		Picker( ): $mol_pick
		items( ): readonly($mol_view)[]
		create( next?: any ): any
		Create_icon( ): $mol_icon_plus
		create_current( ): boolean
		Create( ): $mol_button_minor
		item_label( id: any): string
		item_content( id: any): readonly(any)[]
		item_open( id: any, next?: any ): any
		item_current( id: any): boolean
		value( next?: readonly(string)[] ): readonly(string)[]
		dictionary( ): Record<string, any>
		active( ): string
		open( next?: any ): any
		sub( ): readonly(any)[]
		Item( id: any): $mol_button_minor
		relation_self( ): any
	}
	
}

//# sourceMappingURL=relation.view.tree.d.ts.map